import { Component, OnInit, inject, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { HtmlInputType, ZiroTextConfig } from '../../../../forms/fields/text/ziro-text.component';
import { ZiroSelectConfig } from '../../../../forms/fields/select/ziro-select.component';
import { TranslationPatternFieldConfig } from '../../../../shared/models/generated/ziroModels';
import { ZiroFormConfig, ZiroFormsValidationState } from '../../../../forms/ziro-forms-models';
import { Observable, of } from 'rxjs';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { TranslateService } from '@ngx-translate/core';

export interface TranslationPatternFormData {
  description: string;
  routePartition: string;
  classOfService: string;
}
@Component({
  selector: 'ziro-directory-number-did-details',
  templateUrl: './directory-number-did-details.component.html',
  standalone: false,
})
export class DirectoryNumberDidDetailsComponent
  extends ZiroFormAbstractDirective<TranslationPatternFormData>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;
  private _translateService = inject(TranslateService);

  readonly fieldConfig = input<TranslationPatternFieldConfig>();
  formConfig: ZiroFormConfig;

  ngOnInit(): void {
    this.formConfig = {
      fields: {
        description: {
          label: 'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.didDescription.label',
          dataAutomation: 'dn-did-details-description-input',
          componentConfig: new ZiroTextConfig({ htmlInputType: HtmlInputType.TEXT }),
          required: this.fieldConfig().description.required,
          hidden: () => !this.fieldConfig().description.show,
          defaultValue: () => this.fieldConfig().description.defaultValue,
          validation: [
            {
              validator: (val: string) => {
                return val.length > 50 ? ZiroFormsValidationState.INVALID : ZiroFormsValidationState.VALID;
              },
              message: this._translateService.instant('tkey;validators.global.error.maxlength', { maxlength: 50 }),
            },
          ],
        },
        classOfService: {
          label: 'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.did_css.label',
          dataAutomation: 'dn-did-details-css-input',
          componentConfig: new ZiroSelectConfig({ options: this.fieldConfig().classOfService.possibleOptions }),
          required: this.fieldConfig().classOfService.required,
          hidden: () => !this.fieldConfig().classOfService.show,
          defaultValue: () => this.fieldConfig().classOfService.defaultValue,
        },
        routePartition: {
          label: 'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.did_route_partition.label',
          dataAutomation: 'dn-did-details-route-partition-input',
          componentConfig: new ZiroSelectConfig({ options: this.fieldConfig().routePartition.possibleOptions }),
          required: this.fieldConfig().routePartition.required,
          hidden: () => !this.fieldConfig().routePartition.show,
          defaultValue: () => this.fieldConfig().routePartition.defaultValue,
        },
      },
    };
  }

  protected submit(): Observable<null> {
    return of(null);
  }
}
